import { AnalysisConfigJsonParsingService } from "@/components/AnalysisConfig/services/AnalysisConfigJsonParsingService";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { JsonEditorSchemaType } from "../models/JsonEditorCdnSchemaType";
import { SchemaJsonValidationService } from "./SchemaJsonValidationService";
import { CalculationsJsonParsingService } from "@/components/CustomCalculations/services/CalculationsJsonParsingService";
import { CustomReportsJsonParsingService } from "@/components/CustomReports/services/CustomReportsJsonParsingService";
import { PlottingJsonParsingService } from "@/components/Plotting/services/PlottingJsonParsingService";
import { DataCleaningJsonParsingService } from "@/components/DataCleaning/services/DataCleaningJsonParsingService";
import { TablesJsonParsingService } from "@/components/Tables/services/TablesJsonParsingService";
import { ISchema } from "@/shared/models/ISchema";


export class CdnSchemaJsonValidator {


    public static validateJsonForCdnSchemaType = <TEntity, TJsonParsingInputType>(
        schemaType: JsonEditorSchemaType,
        json: string,
        entitySchemas: Array<ISchema>): CdnSchemaJsonParsingResult<TEntity, TJsonParsingInputType> => {

        if (!schemaType) throw Error("schemaType is required.");
        if (json == null) throw Error("json is required.");
        if (entitySchemas == null) throw Error("entitySchemas are required.");

        const jsonParsingService = CdnSchemaJsonValidator.resolveJsonParsingServiceForCdnSchemaType(schemaType);

        const result = jsonParsingService.tryParseEntitiesFromJson(json, entitySchemas);

        return result;

    }



    private static resolveJsonParsingServiceForCdnSchemaType = (schemaType: JsonEditorSchemaType): SchemaJsonValidationService<any, any, any> => {

        switch (schemaType) {

            case JsonEditorSchemaType.AnalysisConfigSchema:
                return new AnalysisConfigJsonParsingService();
            case JsonEditorSchemaType.CalculationSchema:
                return new CalculationsJsonParsingService();
            case JsonEditorSchemaType.CustomReportSchema:
                return new CustomReportsJsonParsingService();
            case JsonEditorSchemaType.PlotSchema:
                return new PlottingJsonParsingService();
            case JsonEditorSchemaType.RuleSchema:
                return new DataCleaningJsonParsingService();
            case JsonEditorSchemaType.TableSchema:
                return new TablesJsonParsingService();
            default:
                throw Error(`unable to resolve jsonParsingService for schemaType: ${schemaType}!`);
        }

    }

}